import React from "react";

const HeroSection = () => {
  return (
    <section className="relative bg-black text-white min-h-screen flex flex-col justify-center items-center px-6 overflow-hidden">
      {/* Text Content */}
      <h1 className="text-4xl md:text-6xl font-bold text-center leading-tight relative z-10">
      Code. Create. Conquer. <br /> Through Innovative Solutions
      </h1>
      {/* <p className="text-lg md:text-xl mt-6 text-center max-w-2xl relative z-10">
        We are a versatile technology partner dedicated to building impactful products, delivering 
        transformative solutions, and empowering businesses and individuals to thrive in the digital age.
      </p> */}
      <p className="text-lg md:text-xl mt-6 text-center max-w-2xl relative z-10">
      As your end-to-end technology partner, we bring speed, clarity, and creativity 
      to every phase—helping you go from concept to launch with confidence and quality.
      </p>
      <a href="tel:+9196323 83629">
      <button className="bg-green-500 px-6 py-3 mt-8 text-lg font-semibold rounded-md hover:bg-green-400 relative z-10">
        Strategy Call
      </button>
      </a>

      {/* Background Shapes */}
      <div className="absolute bottom-[-50px] left-[-150px] w-[500px] h-[500px] bg-gradient-to-br from-purple-700 via-purple-800 to-transparent rounded-full opacity-40 z-0"></div>
      <div className="absolute top-10 right-0 w-[100px] h-[100px] bg-gradient-to-bl from-blue-500 via-blue-600 to-transparent rounded-full opacity-40 z-0"></div>

      {/* Dots */}
      <div className="absolute top-20 left-16 w-3 h-3 bg-green-500 rounded-full z-0"></div>
      <div className="absolute top-1/4 right-20 w-3 h-3 bg-blue-500 rounded-full z-0"></div>
      <div className="absolute bottom-32 left-1/4 w-3 h-3 bg-orange-500 rounded-full z-0"></div>
      <div className="absolute bottom-10 right-40 w-4 h-4 bg-purple-500 rounded-full z-0"></div>

      {/* Larger Shapes */}
      <div className="absolute top-1/4 left-1/4 w-8 h-8 border-4 border-green-500 rounded-full z-0"></div>
      <div className="absolute bottom-10 left-32 w-6 h-6 bg-blue-500 rounded-lg rotate-45 z-0"></div>
    </section>
  );
};

export default HeroSection;
